import { useContext } from 'react';
import { ChatRoomContext } from 'contexts/chat_room_context';

const useChatRoom = () => {
    return useContext(ChatRoomContext);
};

export default useChatRoom;
